import { render } from "./training-list.vue?vue&type=template&id=2d854b71"
import script from "./training-list.vue?vue&type=script&lang=js"
export * from "./training-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__